import React, { Component } from 'react';
import './StatModelMoreInfo.css';
import Table from 'react-bootstrap/Table';
import MoreInfoTables, { requests, tables } from './Tables/MoreInfoTables';

class InnerSeverityOfHearing extends Component {
    render () {
        return (
          <div>
            <p>
              Severity of hearing loss categories were defined by ranges of unaided air conduction PTA audiometric thresholds (500 Hz, 1000 Hz, 2000 Hz, 4000 Hz). The PTA ranges are:
            </p>
            <ul className="moreinfo-ul">
              <li>Moderate (40 to 60): Pure Tone Average (dBHL): 40 to 60</li>
              <li>Severe (60 to 80): Pure Tone Average (dBHL): 60 to 80</li>
              <li>Severe to profound (80 to 90): Pure Tone Average (dBHL): 80 to 90</li>
              <li>Profound (90 to 100): Pure Tone Average (dBHL): 90 to 100</li>
              <li>Profound (100+): Pure Tone Average (dBHL): 100+</li>
            </ul>
            <p>
              Subjects of the Retrospective Study were filtered based on their preoperative unaided audiograms conforming to presbycusis style hearing loss or sensory neural hearing loss with high a frequency roll-off. Thereafter they were categorised according to their unaided air conduction PTA. One thousand two hundred and eighty-six subjects remained after filtering and the following data was retrieved for each subject:
            </p>
            <ul className="moreinfo-ul">
              <li>Preoperative air conduction audiogram</li>
              <li>Preoperative aided CNC speech discrimination score</li>
              <li>Duration of hearing loss</li>
            </ul>
            <p>
              Average characteristics of each severity of hearing loss category are calculated by processing the corresponding subject data.The average characteristics of the category are found in Table <MoreInfoTables table={tables.CharacteristicsCategories} request={requests.Index} />.
            </p>
            <MoreInfoTables table={tables.CharacteristicsCategories} request={requests.Title} />
            <div>
              <MoreInfoTables table={tables.CharacteristicsCategories} request={requests.Table} />
            </div>
          </div> 
          );
    }
}

export default InnerSeverityOfHearing;